import cn from 'classnames'
import { FC, ButtonHTMLAttributes } from 'react'

export const themeClassNames = {
  danger: 'btn btn-danger',
  outlinePrimary: 'btn btn-outline-primary',
  primary: 'btn-primary',
  secondary: 'btn btn-secondary',
  tertiary: 'btn-tertiary',
  text: 'btn-link',
}

export const sizeClassNames = {
  default: '',
  large: 'btn-lg',
  small: 'btn-sm',
}

export type ButtonType = ButtonHTMLAttributes<HTMLButtonElement> & {
  iconRight?: string
  iconLeft?: string
  theme?: keyof typeof themeClassNames
  size?: keyof typeof sizeClassNames
}

export const Button: FC<ButtonType> = ({
  children,
  className,
  iconLeft,
  iconRight,
  onMouseUp,
  size = 'default',
  theme = 'primary',
  ...rest
}) => {
  return (
    <button
      type='button'
      {...rest}
      onMouseUp={onMouseUp}
      className={cn(
        { btn: true },
        themeClassNames[theme],
        sizeClassNames[size],
        className,
      )}
    >
      {!!iconLeft && <i className={cn('icon', 'p-1', iconLeft)} />}
      {children}
      {!!iconRight && <i className={cn('icon', 'p-1', iconRight)} />}
    </button>
  )
}

Button.displayName = 'Button'
export default Button
